export enum TableFilterFormElementType {
  Input,
  NumberInput,
  Select,
  Radio,
  DateRangePicker,
  DatePicker,
  Custom,
  RadioDateRangePicker,
  NumberRange,
}
